export enum ExamSteps {
  ASSIGNMENTS = 'ASSIGNMENTS',
  WAITING_FOR_QUESTIONNAIRE = 'WAITING_FOR_QUESTIONNAIRE',
  WAITING_FOR_EXAM = 'WAITING_FOR_EXAM',
  EXAM_STARTED = 'EXAM_STARTED',
  EXAM_COMPLETED = 'EXAM_COMPLETED',
  NOTEBOOKS_COLLECTED_FOR_REVIEW = 'NOTEBOOKS_COLLECTED_FOR_REVIEW',
  GRADES_ENTERED = 'GRADES_ENTERED',
  GRADES_PUBLISHED = 'GRADES_PUBLISHED',
}

export const getExamStatusDisplayText = (examStatus: ExamSteps) => {
  switch (examStatus) {
    case ExamSteps.ASSIGNMENTS:
      return 'שיבוצים';
    case ExamSteps.WAITING_FOR_QUESTIONNAIRE:
      return 'ממתין לשאלון';
    case ExamSteps.WAITING_FOR_EXAM:
      return 'ממתין לבחינה';
    case ExamSteps.EXAM_STARTED:
      return 'הבחינה התחילה';
    case ExamSteps.EXAM_COMPLETED:
      return 'הבחינה התבצעה';
    case ExamSteps.NOTEBOOKS_COLLECTED_FOR_REVIEW:
      return 'מחברות נאספו לבדיקה';
    case ExamSteps.GRADES_ENTERED:
      return 'הוזנו ציונים';
    case ExamSteps.GRADES_PUBLISHED:
      return 'פורסמו ציונים';
  }
};
